import * as React from 'react';

interface Props {
  sources: string[];
  filteredSources: string[];
  handleFilter: (source: string) => void;
}

export default class Filter extends React.Component<Props> {
  render() {
    return (
      <div className="buttons">
        {this.props.sources.sort().map((source) => (
          <button
            key={source}
            className={`button is-small is-rounded ${
              this.props.filteredSources.indexOf(source) !== -1
                ? 'is-primary'
                : 'is-light'
            }`}
            onClick={() => this.props.handleFilter(source)}
          >
            {source}
          </button>
        ))}
      </div>
    );
  }
}
